document.addEventListener("DOMContentLoaded", function() {
    function isOverflowing(element) {
        // Determines if the element's width is greater than the viewport.
        return element.scrollWidth > element.offsetWidth;
    }

    var breadcrumbs = document.querySelectorAll(".c-breadcrumbs__list");

    // Convert NodeList to array and use the filter function
    Array.from(breadcrumbs).filter(function(thisBC) {
        return (
            isOverflowing(thisBC) && thisBC.parentNode.parentNode.parentNode.classList.contains("c-hero-top-bar")
        );
    }).forEach(function(thisBC) {
        var parent = thisBC.parentNode.parentNode.parentNode;
        parent.classList.add("c-breadcrumbs--overflow");
    });
});
